import { Component, inject, Input } from '@angular/core';
import { Params } from '@angular/router';
import { RoutingService } from '../../service/common/routing/routing.service';
import { ErzeugungsanlageFilter } from '../../service/erzeugungsanlage/erzeugungsanlage-filter';

@Component({
    selector: 'redispatch-dashboard-netzzuordnungen',
    templateUrl: './dashboard-netzzuordnungen.component.html',
    styleUrls: [
        './dashboard-netzzuordnungen.component.scss',
    ],
    standalone: false,
})
export class DashboardNetzzuordnungenComponent {

    @Input()
    public invalidNetzzuordnungen?: number = null;

    private routingService = inject(RoutingService);

    public get hasInvalidNetzzuordnungen(): boolean {
        return this.invalidNetzzuordnungen > 0;
    }

    public get routerLink(): string | null {
        return this.routingService.erzeugungsanlagePath();
    }

    public get queryParams(): Params | null {
        if (this.hasInvalidNetzzuordnungen) {
            return { status: false } as ErzeugungsanlageFilter;
        } else {
            return null;
        }
    }

}
